import { useSelector } from 'react-redux'

import { getGenderRestrictionString } from '~/components/common/inputs/gender/genderUtils'
import { getGender, getSpayedNeuteredStatus } from '~/store/reducers/constants'
import type { SpayedNeuteredGenderType } from '~/types'

export type GenderRestrictionsCellItem = {
  genderRestrictions: SpayedNeuteredGenderType[]
}

const GenderRestrictionsCell = (item: GenderRestrictionsCellItem) => {
  const Gender = useSelector(getGender)
  const SpayedNeuteredStatus = useSelector(getSpayedNeuteredStatus)

  return getGenderRestrictionString(
    item.genderRestrictions,
    Gender,
    SpayedNeuteredStatus,
  )
}

export default GenderRestrictionsCell
